import { useState, useEffect, useCallback } from 'react';

import { Message } from '../..';

import { getSMSCode } from '../../../service/api/SMS/apiSMS';

const ResetPasswordModal = ({ deliver, onSubmit, onCancel }) => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [verifyCode, setVerifyCode] = useState('');
    const [error, setError] = useState('');
    
    // SMS 驗證相關狀態
    const [smsCountdown, setSmsCountdown] = useState(0);
    const [smsSending, setSmsSending] = useState(false);

    // SMS 倒數計時
    useEffect(() => {
        if (smsCountdown > 0) {
            const timer = setTimeout(() => setSmsCountdown(smsCountdown - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [smsCountdown]);

    // 發送簡訊驗證碼
    const handleSendSMS = useCallback(async () => {
        if (!deliver?.phone) {
            Message('該司機沒有手機號碼', 'warning');
            return;
        }
        
        setSmsSending(true);
        try {
            const response = await getSMSCode({ phone: deliver.phone });
            if (response.data.status === 1) {
                Message('驗證碼已發送');
                setSmsCountdown(30);
            } else {
                Message(response.data.message || '發送失敗', 'warning');
            }
        } catch (error) {
            Message('發送驗證碼失敗', 'error');
        } finally {
            setSmsSending(false);
        }
    }, [deliver?.phone]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        // 驗證
        if (!newPassword || !confirmPassword) {
            setError('密碼不能為空');
            return;
        }

        if (newPassword.length < 6) {
            setError('密碼長度至少 6 個字符');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('兩次輸入的密碼不一致');
            return;
        }

        onSubmit({ newPassword, verifyCode, phone: deliver.phone });
    };

    if (!deliver) return null;

    return (
        <div className="reset-password-modal">
            <h4 className="mb-4 text-center">
                <i className="fas fa-key me-2"></i>重設密碼
            </h4>
            <p className="text-muted text-center mb-3">
                司機：<strong>{deliver.name}</strong>
                {deliver.phone && <span className="ms-2">({deliver.phone})</span>}
            </p>

            <form onSubmit={handleSubmit}>
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}

                <div className="mb-3">
                    <label htmlFor="newPassword" className="form-label">
                        新密碼
                    </label>
                    <input
                        type="password"
                        id="newPassword"
                        className="form-control"
                        placeholder="請輸入新密碼（至少 6 個字符）"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="confirmPassword" className="form-label">
                        確認密碼
                    </label>
                    <input
                        type="password"
                        id="confirmPassword"
                        className="form-control"
                        placeholder="請再次輸入密碼"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                </div>

                {/* <div className="mb-4">
                    <label htmlFor="verifyCode" className="form-label">
                        簡訊驗證碼
                    </label>
                    <div className="input-group">
                        <input
                            type="text"
                            id="verifyCode"
                            className="form-control"
                            placeholder="請輸入 6 位數驗證碼"
                            value={verifyCode}
                            onChange={(e) => setVerifyCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                            maxLength={6}
                            required
                        />
                        <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={handleSendSMS}
                            disabled={smsCountdown > 0 || smsSending || !deliver?.phone}
                        >
                            {smsSending ? '發送中...' : smsCountdown > 0 ? `${smsCountdown}秒` : '發送驗證碼'}
                        </button>
                    </div>
                    {!deliver?.phone && (
                        <small className="text-danger">該司機沒有設定手機號碼，無法發送驗證碼</small>
                    )}
                </div> */}

                <div className="d-flex gap-2 justify-content-end">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onCancel}
                    >
                        取消
                    </button>
                    <button
                        type="submit"
                        className="btn btn-warning"
                    >
                        確認重設
                    </button>
                </div>
            </form>
        </div>
    );
};

export { ResetPasswordModal };
